import React, { useState } from 'react'
import { Menu, MenuItem } from '@mui/material'
import Icon from '../../shared/icon'
import { t } from '../../../i18n'
import { ActionItem } from '../types'

const scope = 'orders'

interface LinkAttributes {
  'data-method'?: 'put' | 'post'
  'data-confirm'?: string
}

const linkAttributes = (item: ActionItem): LinkAttributes => {
  if (!item.method) return {}

  return {
    'data-method': item.method,
    'data-confirm': item.confirm || t('global.confirm')
  }
}

const ActionsMenu = ({ items }: { items: ActionItem[] }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)

  if (!items.length) return null

  const open = Boolean(anchorEl)
  const openMenu = (event: React.MouseEvent<HTMLButtonElement>) => setAnchorEl(event.currentTarget)
  const closeMenu = () => setAnchorEl(null)

  return (
    <>
      <button
        type='button'
        className='actions-menu__trigger'
        aria-label={t('actions', { scope })}
        onClick={openMenu}
      >
        <Icon name='actionButton' />
      </button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={closeMenu}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        slotProps={{ paper: { className: 'actions-menu__paper' } }}
        MenuListProps={{ className: 'py-2' }}
      >
        {items.map(item =>
          <MenuItem
            key={item.key}
            component='a'
            href={item.href}
            {...linkAttributes(item)}
            className={item.danger ? 'text-danger' : undefined}
            onClick={closeMenu}
          >
            {item.label}
          </MenuItem>
        )}
      </Menu>
    </>
  )
}

export default ActionsMenu
